export function generateUniqueHexCode(): string {
  // Generate a random 6-digit hex code
  const hexCode = Math.floor(Math.random() * 0xFFFFFF)
    .toString(16)
    .toUpperCase()
    .padStart(6, '0');
  
  return hexCode;
}